import React from "react";
import { Box, Grid } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { Custom, Item } from "components";
import { ProjectType } from "types";
import { Projects } from "assets/data";

type Props = {};

export const Project = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const projects = Projects.filter((item: ProjectType) => item.active);

  return (
    <Box
      component="section"
      id="project"
      sx={{ pt: { xs: theme.spacing.xl, md: theme.spacing.xxl }, pb: theme.spacing.sm, width: "100%", position: "relative" }}
    >
      {/* Section Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "flex-end" },
          justifyContent: "space-between",
          mb: theme.spacing.xl,
          gap: theme.spacing.sm,
        }}
      >
        <Box>
          <Box
            sx={{
              fontFamily: '"Space Mono", monospace',
              fontSize: theme.font.xxs,
              fontWeight: theme.font.bold,
              color: theme.color.primary.color,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            {t.sections?.project_badge || "SECTION 03 // CURATED WORKS"}
          </Box>
          <Custom.Typography
            variant="h2"
            sx={{
              fontSize: { xs: theme.font.xl, md: theme.font.xxl },
              fontWeight: theme.font.extraBold,
              letterSpacing: "-0.02em",
              mt: theme.spacing.xxs,
            }}
          >
            {t.title.project}
          </Custom.Typography>
        </Box>
        <Custom.Typography
          variant="body2"
          sx={{
            color: theme.color.font.accent,
            maxWidth: 420,
            fontSize: theme.font.xs,
            lineHeight: 1.6,
          }}
        >
          {t.sections.project_summary}
        </Custom.Typography>
      </Box>

      {/* Projects Grid */}
      <Grid container spacing={theme.spacing.lg}>
        {projects.map((project: ProjectType, i: number) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Item.Project item={project} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};